import { render } from "./toasts.vue?vue&type=template&id=1922d760"
import script from "./toasts.vue?vue&type=script&lang=js"
export * from "./toasts.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__